<template>
  <div class="page-container">
    <el-card v-loading="loading">
      <div slot="header" class="page-header">
        <span class="page-title">商品订单详情</span>
        <div class="page-actions">
          <el-button
            v-if="detail.refund_apply_status === 1"
            v-permission="['order:product:refund']"
            type="danger" size="small" icon="el-icon-money"
            @click="openRefundDialog"
          >发起退款</el-button>
          <el-button size="small" icon="el-icon-arrow-left" @click="$router.push('/order/product')">返回列表</el-button>
        </div>
      </div>

      <template v-if="detail.id">

        <!-- ① 订单信息 -->
        <div class="section-title">订单信息</div>
        <el-form label-width="120px" size="small" class="detail-form">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="商品订单号"><span class="val-text">{{ detail.order_no }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单状态">
                <el-tag :type="orderStatusType(detail.status)" size="small">
                  {{ detail.status_label || orderStatusLabel(detail.status) }}
                </el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户姓名"><span class="val-text">{{ detail.buyer_name || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号"><span class="val-text">{{ detail.buyer_phone || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="下单时间"><span class="val-text">{{ detail.created_at || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品名称"><span class="val-text">{{ detail.product_name || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="数量"><span class="val-text">{{ detail.quantity }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品金额"><span class="val-text">¥{{ toFixed2(detail.total_amount) }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="抵扣金额"><span class="val-text">¥{{ toFixed2(detail.discount_amount) }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单金额">
                <span class="val-text">¥{{ toFixed2(Number(detail.total_amount || 0)) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="实付金额"><span class="val-price">¥{{ toFixed2(detail.pay_amount) }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付方式"><span class="val-text">{{ detail.pay_method_label || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付号"><span class="val-text">{{ detail.pay_no || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付时间"><span class="val-text">{{ detail.paid_at || '—' }}</span></el-form-item>
            </el-col>
            <template v-if="detail.status === 4">
              <el-col :span="12">
                <el-form-item label="退款金额"><span class="val-price">¥{{ toFixed2(detail.refund_total_amount) }}</span></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="退款时间"><span class="val-text">{{ detail.last_refunded_at || '—' }}</span></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="退款操作人员"><span class="val-text">{{ detail.last_refund_operator || '—' }}</span></el-form-item>
              </el-col>
            </template>
            <template v-if="detail.status === 5">
              <el-col :span="12">
                <el-form-item label="完成时间"><span class="val-text">{{ detail.completed_at || '—' }}</span></el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>

        <!-- ② 服务订单列表 -->
        <div class="section-title">服务订单</div>
        <el-table :data="serviceOrders" v-loading="serviceLoading" border stripe style="width:100%" max-height="320">
          <el-table-column prop="service_no" label="服务订单号" min-width="190" show-overflow-tooltip />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="svcStatusType(row.status)" size="small">
                {{ row.status_label || svcStatusLabel(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="用户姓名" width="110">
            <template slot-scope="{ row }">{{ row.user_name || '—' }}</template>
          </el-table-column>
          <el-table-column label="联系方式" width="130">
            <template slot-scope="{ row }">{{ row.user_phone || '—' }}</template>
          </el-table-column>
          <el-table-column label="预约上门地址" min-width="150" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.appointment_address || '—' }}</template>
          </el-table-column>
          <el-table-column label="预约上门时间" width="160">
            <template slot-scope="{ row }">{{ row.appointment_at || '—' }}</template>
          </el-table-column>
          <el-table-column label="商品名称" min-width="150" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.product_name || '—' }}</template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button
                v-permission="['order:service:detail']"
                type="primary" size="mini" icon="el-icon-view"
                @click="$router.push(`/order/service/detail?id=${row.id}`)"
              >详情</el-button>
              <el-button
                v-if="row.status === 2"
                v-permission="['order:service:assignCollector']"
                type="warning" size="mini" icon="el-icon-user"
                @click="openAssignDialog(row)"
              >分配</el-button>
              <el-button
                v-if="row.status === 6"
                v-permission="['order:service:uploadReport']"
                type="success" size="mini" icon="el-icon-upload2"
                @click="openReportDialog(row)"
              >上传报告</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- ③ 退款记录 -->
        <div class="section-title">退款记录</div>
        <el-table :data="refundRecords" v-loading="refundLoading" border stripe style="width:100%" max-height="260">
          <el-table-column prop="refund_no" label="退款订单号" min-width="190" show-overflow-tooltip />
          <el-table-column prop="operator" label="退款操作人" width="110" />
          <el-table-column prop="created_at" label="操作时间" width="160" />
          <el-table-column label="退款金额" width="110" align="right">
            <template slot-scope="{ row }">
              <span class="val-price">¥{{ toFixed2(row.amount) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="退款备注" min-width="120" show-overflow-tooltip />
          <el-table-column prop="refunded_at" label="退款时间" width="160" />
          <el-table-column label="退款状态" width="90" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="refundStatusType(row.status)" size="small">
                {{ row.status_label || refundStatusLabel(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="fail_reason" label="退款失败原因" min-width="140" show-overflow-tooltip />
        </el-table>

        <!-- ④ 优惠券使用信息 -->
        <div class="section-title">优惠券使用信息</div>
        <el-table :data="detail.coupons || []" border stripe style="width:100%" max-height="260">
          <el-table-column prop="record_id" label="记录ID" width="90" align="center" />
          <el-table-column prop="coupon_name" label="优惠券名称" min-width="160" show-overflow-tooltip />
          <el-table-column label="面值" width="110" align="right">
            <template slot-scope="{ row }">
              <span class="val-price">¥{{ toFixed2(row.amount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="couponStatusType(row.status)" size="small">
                {{ couponStatusLabel(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="核销时间" width="160">
            <template slot-scope="{ row }">{{ row.used_at || '—' }}</template>
          </el-table-column>
          <template slot="empty">
            <span style="color:#909399">该订单未使用优惠券</span>
          </template>
        </el-table>

      </template>
    </el-card>

    <!-- 采血师分配弹框 -->
    <el-dialog title="分配采血师" :visible.sync="assignDialog.visible" width="460px" @close="resetAssignForm">
      <el-form ref="assignForm" :model="assignForm" :rules="assignRules" label-width="120px" size="small">
        <el-form-item label="采血师姓名" prop="collector_name">
          <el-input v-model="assignForm.collector_name" placeholder="请输入采血师姓名" />
        </el-form-item>
        <el-form-item label="采血师手机号" prop="collector_phone">
          <el-input v-model="assignForm.collector_phone" placeholder="请输入采血师手机号" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="assignDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="assignDialog.submitting" @click="submitAssign">确定</el-button>
      </span>
    </el-dialog>

    <!-- 上传检测报告弹框 -->
    <el-dialog title="上传检测报告" :visible.sync="reportDialog.visible" width="440px" @close="resetReportDialog">
      <div class="upload-hint">请选择 PDF 格式的检测报告文件</div>
      <el-upload
        ref="reportUpload"
        action="#"
        accept=".pdf"
        :limit="1"
        :auto-upload="false"
        :on-change="onReportFileChange"
        :on-remove="() => { reportDialog.file = null }"
        :file-list="[]"
      >
        <el-button size="small" icon="el-icon-folder-opened">选择文件</el-button>
        <span slot="tip" class="el-upload__tip" style="margin-left:8px">仅支持 .pdf</span>
      </el-upload>
      <span slot="footer">
        <el-button @click="reportDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="reportDialog.submitting" @click="submitReport">确定上传</el-button>
      </span>
    </el-dialog>

    <!-- 退款弹框 -->
    <el-dialog
      title="请选择要退款的服务订单，并设置退款金额"
      :visible.sync="refundDialog.visible"
      width="1000px"
      @close="resetRefundForm"
    >
      <div v-loading="refundDialog.loading">
        <div class="refund-tip">
          可退最大金额：<strong class="val-price">¥{{ toFixed2(refundDialog.maxAmount) }}</strong>
        </div>

        <el-table
          ref="refundTable"
          :data="refundDialog.serviceOrders"
          border
          style="width:100%;margin-bottom:16px"
          @selection-change="rows => refundDialog.selectedIds = rows.map(r => r.id)"
        >
          <el-table-column type="selection" width="50" align="center" />
          <el-table-column prop="service_no" label="服务订单号" min-width="180" show-overflow-tooltip />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="svcStatusType(row.status)" size="small">
                {{ row.status_label || svcStatusLabel(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" min-width="140" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.product_name || '—' }}</template>
          </el-table-column>
          <el-table-column label="商品金额" min-width="140" show-overflow-tooltip>
            <template slot-scope="{ row }"><span class="val-text">¥{{ toFixed2(row.product_price) }}</span></template>
          </el-table-column>
        </el-table>

        <el-form :model="refundDialog" label-width="90px" size="small">
          <el-form-item label="退款金额">
            <el-input-number
              v-model="refundDialog.amount"
              :precision="2" :step="1" :min="0.01" :max="refundDialog.maxAmount || 9999"
              :placeholder="null"
              controls-position="right"
              style="width:200px"
            />
            <span class="tip-text">最多可退 ¥{{ toFixed2(refundDialog.maxAmount) }}</span>
          </el-form-item>
          <el-form-item label="退款备注">
            <el-input
              v-model="refundDialog.remark"
              type="textarea" :rows="2"
              placeholder="可选"
              style="width:500px"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="refundDialog.visible = false">取消</el-button>
        <el-button type="danger" :loading="refundDialog.submitting" @click="submitRefund">确认退款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProductOrderDetail,
  getRefundableAmount,
  getRefundableServiceOrders,
  refundProductOrder,
  getProductOrderRefundRecords,
  getProductOrderServiceList,
  assignCollector,
  uploadReport
} from '@/api/order'

const ORDER_STATUS = {
  0: { label: '待付款', type: 'warning' },
  1: { label: '已付款', type: 'success' },
  2: { label: '部分退款', type: '' },
  3: { label: '已取消', type: 'info' },
  4: { label: '已退款', type: 'danger' },
  5: { label: '已完成', type: 'success' }
}
const SERVICE_STATUS = {
  0: { label: '待录入', type: 'info' },
  1: { label: '待服务', type: 'warning' },
  2: { label: '待分配', type: 'warning' },
  3: { label: '待联系', type: '' },
  4: { label: '待上门', type: '' },
  5: { label: '待发件', type: '' },
  6: { label: '待检测', type: '' },
  7: { label: '已完成', type: 'success' },
  8: { label: '已退款', type: 'danger' }
}
const REFUND_STATUS = {
  0: { label: '处理中', type: 'warning' },
  1: { label: '已退款', type: 'success' },
  2: { label: '退款失败', type: 'danger' }
}
const COUPON_STATUS = {
  0: { label: '未使用', type: 'info' },
  1: { label: '已使用', type: 'success' },
  2: { label: '已冻结', type: 'warning' }
}

export default {
  name: 'ProductOrderDetail',
  data() {
    return {
      loading: false,
      serviceLoading: false,
      refundLoading: false,
      detail: {},
      serviceOrders: [],
      refundRecords: [],
      refundDialog: {
        visible: false,
        loading: false,
        submitting: false,
        serviceOrders: [],
        selectedIds: [],
        maxAmount: 0,
        amount: null,
        remark: ''
      },
      assignDialog: {
        visible: false,
        submitting: false,
        serviceOrderId: null
      },
      assignForm: { collector_name: '', collector_phone: '' },
      assignRules: {
        collector_name:  [{ required: true, message: '请输入采血师姓名', trigger: 'blur' }],
        collector_phone: [{ required: true, message: '请输入采血师联系方式', trigger: 'blur' }]
      },
      reportDialog: {
        visible: false,
        submitting: false,
        serviceOrderId: null,
        file: null
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.path !== '/order/product/detail') return
        if (to.query.id) this.init(Number(to.query.id))
      }
    }
  },
  methods: {
    async init(id) {
      this.loading = true
      this.serviceLoading = true
      this.refundLoading = true
      try {
        const [detailRes, serviceRes, refundRes] = await Promise.all([
          getProductOrderDetail({ order_id: id }),
          getProductOrderServiceList({ order_id: id }),
          getProductOrderRefundRecords({ order_id: id })
        ])
        this.detail = detailRes.data || {}
        this.serviceOrders = serviceRes.data || []
        this.refundRecords = refundRes.data || []
      } catch {
        this.$message.error('加载失败，请重试')
      } finally {
        this.loading = false
        this.serviceLoading = false
        this.refundLoading = false
      }
    },

    async openRefundDialog() {
      this.refundDialog.visible = true
      this.refundDialog.loading = true
      this.refundDialog.selectedIds = []
      this.refundDialog.amount = null
      this.refundDialog.remark = ''
      try {
        const id = Number(this.$route.query.id)
        const [serviceRes, amountRes] = await Promise.all([
          getRefundableServiceOrders({ order_id: id }),
          getRefundableAmount({ order_id: id })
        ])
        this.refundDialog.serviceOrders = serviceRes.data || []
        this.refundDialog.maxAmount = ((amountRes.data || {}).refundable_amount) || 0
      } finally {
        this.refundDialog.loading = false
      }
    },

    async submitRefund() {
      if (!this.refundDialog.selectedIds.length) {
        return this.$message.warning('请选择要退款的服务订单')
      }
      if (!this.refundDialog.amount || this.refundDialog.amount <= 0 || this.refundDialog.amount > this.refundDialog.maxAmount) {
        return this.$message.warning('请输入正确的退款金额')
      }
      this.refundDialog.submitting = true
      try {
        await refundProductOrder({
          order_id: Number(this.$route.query.id),
          service_order_ids: this.refundDialog.selectedIds,
          amount: this.refundDialog.amount,
          remark: this.refundDialog.remark || undefined
        })
        this.$message.success('退款申请已提交，结果将通过回调更新')
        this.refundDialog.visible = false
        this.init(Number(this.$route.query.id))
      } catch {
        this.reloadRefundRecords()
      } finally {
        this.refundDialog.submitting = false
      }
    },

    resetRefundForm() {
      this.refundDialog.selectedIds = []
      this.refundDialog.amount = null
      this.refundDialog.remark = ''
    },

    // ── 采血师分配 ──
    openAssignDialog(row) {
      this.assignDialog.serviceOrderId = row.id
      this.assignDialog.visible = true
    },
    resetAssignForm() {
      this.assignForm = { collector_name: '', collector_phone: '' }
      if (this.$refs.assignForm) this.$refs.assignForm.clearValidate()
    },
    async submitAssign() {
      const valid = await this.$refs.assignForm.validate().catch(() => false)
      if (!valid) return
      this.assignDialog.submitting = true
      try {
        await assignCollector({
          service_order_id: this.assignDialog.serviceOrderId,
          collector_name: this.assignForm.collector_name,
          collector_phone: this.assignForm.collector_phone
        })
        this.$message.success('采血师分配成功')
        this.assignDialog.visible = false
        this.reloadServiceOrders()
      } finally {
        this.assignDialog.submitting = false
      }
    },

    // ── 上传检测报告 ──
    openReportDialog(row) {
      this.reportDialog.serviceOrderId = row.id
      this.reportDialog.file = null
      this.reportDialog.visible = true
    },
    onReportFileChange(file) {
      this.reportDialog.file = file.raw
    },
    resetReportDialog() {
      this.reportDialog.file = null
      this.reportDialog.serviceOrderId = null
      if (this.$refs.reportUpload) this.$refs.reportUpload.clearFiles()
    },
    async submitReport() {
      if (!this.reportDialog.file) {
        return this.$message.warning('请先选择 PDF 文件')
      }
      this.reportDialog.submitting = true
      try {
        await uploadReport(this.reportDialog.serviceOrderId, this.reportDialog.file)
        this.$message.success('检测报告上传成功')
        this.reportDialog.visible = false
        this.reloadServiceOrders()
      } catch (e) {
        this.$message.error(e.message || '上传失败，请重试')
      } finally {
        this.reportDialog.submitting = false
      }
    },

    async reloadServiceOrders() {
      this.serviceLoading = true
      try {
        const res = await getProductOrderServiceList({ order_id: Number(this.$route.query.id) })
        this.serviceOrders = res.data || []
      } finally {
        this.serviceLoading = false
      }
    },

    async reloadRefundRecords() {
      this.refundLoading = true
      try {
        const res = await getProductOrderRefundRecords({ order_id: Number(this.$route.query.id) })
        this.refundRecords = res.data || []
      } finally {
        this.refundLoading = false
      }
    },

    orderStatusType(s) { return (ORDER_STATUS[s] || {}).type || '' },
    orderStatusLabel(s) { return (ORDER_STATUS[s] || {}).label || String(s) },
    svcStatusType(s) { return (SERVICE_STATUS[s] || {}).type || '' },
    svcStatusLabel(s) { return (SERVICE_STATUS[s] || {}).label || String(s) },
    refundStatusType(s) { return (REFUND_STATUS[s] || {}).type || '' },
    refundStatusLabel(s) { return (REFUND_STATUS[s] || {}).label || String(s) },
    couponStatusType(s) { return (COUPON_STATUS[s] || {}).type || '' },
    couponStatusLabel(s) { return (COUPON_STATUS[s] || {}).label || String(s) },
    toFixed2(val) { return Number(val || 0).toFixed(2) }
  }
}
</script>

<style lang="scss" scoped>
.page-header  { display: flex; justify-content: space-between; align-items: center; }
.page-title   { font-size: 16px; font-weight: 600; }
.page-actions { display: flex; gap: 8px; }

.section-title {
  font-size: 14px; font-weight: 600; color: #303133;
  margin: 24px 0 12px;
  padding-left: 10px;
  border-left: 3px solid #409EFF;
}

.detail-form { padding: 0 12px; }

.val-text  { color: #303133; }
.val-price { color: #f56c6c; font-weight: 600; }

.refund-tip  { margin-bottom: 14px; font-size: 14px; }
.tip-text    { margin-left: 10px; color: #909399; font-size: 12px; }
.upload-hint { color: #606266; font-size: 13px; margin-bottom: 12px; }
</style>
